import React from 'react';
import { Link } from 'react-router-dom';
import { generateResizedImageUrl } from "../../../utils/httpService";

const NewsCard = ({ item, fallbackCategoryName }) => {
  const itemMedia = item.media || item.image_path || item.image;
  const itemImg = itemMedia
    ? (itemMedia.startsWith("http") ? itemMedia : `${itemMedia.startsWith('/') ? itemMedia.slice(1) : itemMedia}`)
    : null;

  // For the red band on the image, use a category or fallback
  const imageTagline = item.category || item.category_name_guj || item.tagline || fallbackCategoryName || "સમાચાર";

  return (
    <Link
      target="_parent"
      to={`/${item.url}`}
      className="news-grid-card"
      title={item.title || item.gujarati_title || item.name}
      style={{ display: 'flex', flexDirection: 'column', height: '100%', textDecoration: 'none' }}
    >
      <div className="news-grid-card-inner">
        <div className="news-grid-img-wrapper">
          {itemImg ? (
            <img
              loading="lazy"
              src={generateResizedImageUrl(310, 174, itemImg)}
              alt={item.title || item.gujarati_title || item.name}
              title={item.title || item.gujarati_title || item.name}
              className="news-grid-img"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          ) : (
            <div className="news-grid-img-placeholder"></div>
          )}

          {/* Removed Red Band Overlay as requested */}
          {(item.type === 'video' || item.news_type === 'video') && (
            <p className="playicon-subhome">
              <i className="fas fa-play"></i>
            </p>
          )}
          <div className="watermark-container">
            <img src={"assets/images/sandesh-logo-watermark.png"} alt="Sandesh" className="watermark-img" onError={(e) => e.target.style.display = 'none'} />
          </div>
        </div>

        <div className="news-grid-content">
          <div className="news-grid-meta-top">
            {parseInt(item.is_live) === 1 && (
              <span className="live-now-badge">
                <span className="live-now-dot"></span>
                LIVE
              </span>
            )}
            {/* Secondary red tagline next to live badge, like in screenshot */}
            {item.tagline && (
              <span className="news-grid-tagline-text">
                {item.tagline}
              </span>
            )}
          </div>

          <h2 className="news-grid-title">
            {item.title || item.gujarati_title || item.name}
          </h2>

          <div className="news-grid-footer">
            <span className="news-grid-readmore">
              વાંચો
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default NewsCard;
